import { shape, func } from 'prop-types';

export default shape({
    search: func,
    searchForFacetvalues: func,
});
